import { useLocalesContext } from 'utils/contexts/locales/localeSettings';
import { InsightTable } from './InsightTable';
import { useProfileQueryContext } from './contexts';
import { useTranslation } from '../hooks';

export const LocalesTable = () => {
  const { t } = useTranslation();
  const { hasLocales } = useLocalesContext();
  const { locales } = useProfileQueryContext();
  const title = t('insights.locales');

  const isLocaleTableVisible = hasLocales && !!locales?.length;

  return (
    <InsightTable
      title={title}
      values={locales ?? []}
      hasChart
      showDivider
      isEnabled={isLocaleTableVisible}
    />
  );
};
